export default "__VITE_PUBLIC_ASSET__c7493d34__"